<template>
  <form name="permissions-groups-form" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col sm="6" lg="5">
          <BTextField
            v-model="form.name"
            validate="required"
            label="Название"
            :disabled="isView"
            :skeleton="skeleton"
            name="name"
            autofocus
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="6" lg="5">
          <v-checkbox
            v-model="form.check_user_ate"
            :disabled="isView"
            readonly
            label="Проверить принадлежность пользователя к АТЕ?"
            dense
            hide-details
            class="ma-0 pa-0"
            name="check_user_ate"
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <v-alert
      :value="!isView && !form.check_user_ate"
      type="warning"
    >
      Пользователи данной группы имеют права на все объекты АТЕ группы
    </v-alert>

    <BLayoutExpansionTable
      v-model="form.users"
      :actions="actions"
      :readonly="isView"
      :skeleton="skeleton"
      type-autocomplete="user-group"
      type-table="users"
      title="Пользователи"
      class="mb-4"
      name="users"
    />

    <BLayoutExpansionTable
      v-model="form.permissions"
      :actions="actions"
      :readonly="isView"
      :skeleton="skeleton"
      type-autocomplete="permission"
      type-table="permissions"
      title="Права"
      class="mb-4"
      name="permissions"
    />

    <BLayoutExpansion title="Дерево ATE" class="mb-4">
      <BAteTree
        :regions.sync="form.regions"
        :municipalities.sync="form.municipalities"
        :schools.sync="form.schools"
        model="Group"
        validate="required"
        :readonly="isView"
        :skeleton="skeleton"
        style="margin: 0 -20px -8px;"
      >
        <template #before-counts>
          <BTooltipButton
            depressed
            style-button="height: 40px;"
            class-button="mb-2 mx-2"
            text="Скопировать из списка участников"
            @click="OnCopyAte"
          />
        </template>
      </batetree>
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import { DELETE } from '@/helpers/enums/table-actions'
import { createPermissionsGroupsCopyAteModal } from '../utils'

import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BLayoutExpansionTable from '@/components/layouts/BLayoutExpansionTable.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BAteTree from '@/components/forms/BAteTree.vue'
import BTooltipButton from '@/components/common/BTooltipButton.vue'


export const TABLE_ACTIONS = Object.freeze([
  DELETE,
])

const createDefaultData = () => ({
  // id
  code: '',
  // created_at
  name: '',
  // updated_at
  permissions: [],
  municipalities: [],
  regions: [],
  schools: [],
  users: [],
  check_user_ate: true,
})

export default {
  name: 'PermissionsGroupsForm',
  components: {
    BLayoutExpansion,
    BLayoutExpansionTable,
    BTextField,
    BAteTree,
    BTooltipButton,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  data: () => ({
    actions: TABLE_ACTIONS,
  }),
  methods: {
    async onSubmit() {
      const result = await this.$validator.validate()

      if (!result) {
        this.$notice.validatorFormError(this)
        const message = `Error submit: ${this.$options.name}`
        const error = new Error(message)
        return Promise.reject(error)
      }

      const { form } = this

      const data = {
        ...form,

        users: void 0,
        user_ids: form.users?.map((_) => _.id),

        permissions: void 0,
        permission_ids: form.permissions?.map((_) => _.id),

        regions: void 0,
        region_ids: form.regions?.map((_) => _.id),

        municipalities: void 0,
        municipality_ids: form.municipalities?.map((_) => _.id),

        schools: void 0,
        school_ids: form.schools?.map((_) => _.id).filter(Boolean),
      }

      this.$emit('submit', data)

      return data
    },
    async OnCopyAte() {
      const modal = await createPermissionsGroupsCopyAteModal(this, {})
      const result = await modal.open()
      if (!result) return

      this.form = {
        ...this.form,
        ...result,
      }
    },
  },
}
</script>
